import type { MouseEventHandler } from "react";

import type { IntentSignalEventInfoDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import IntentTopicWithEventInfo from "../SignalEventInfo/IntentSignalEventInfo/IntentTopicWithEventInfo";

import { StyledIntentTopicsListWrapper, StyledIntentSignalEventInfoWrapper } from "./styles";

type Props = {
    className?: string;
    signalEvents: readonly IntentSignalEventInfoDto[];
    onMouseEnter: MouseEventHandler<HTMLDivElement>;
};

const IntentTopicsList = ({ className, signalEvents, onMouseEnter }: Props) => {
    return (
        <StyledIntentTopicsListWrapper className={className}>
            {signalEvents.map((item, index) => (
                <StyledIntentSignalEventInfoWrapper
                    key={index}
                    onMouseEnter={onMouseEnter}
                >
                    <IntentTopicWithEventInfo eventInfo={item} />
                </StyledIntentSignalEventInfoWrapper>
            ))}
        </StyledIntentTopicsListWrapper>
    );
};

export default IntentTopicsList;
